<span class="label-left" *ngIf="labelLeft">{{ labelLeft }}</span>
<div [ngClass]="{ 'avano-toggle': true, 'avano-toggle-checked': checked(), 'avano-toggle-disabled': disabled }" (click)="onClick($event, cb)">
  <div class="input-hidden-accessible">
    <input
      #cb
      type="checkbox"
      [attr.id]="inputId"
      [attr.name]="name"
      [attr.tabindex]="tabindex"
      [checked]="checked()"
      (change)="onInputChange($event)"
      (blur)="onBlur($event)"
      [disabled]="disabled"
      role="switch"
      [attr.aria-checked]="checked()"
      [attr.aria-labelledby]="ariaLabelledBy"
    />
  </div>
  <span class="avano-toggle-handle"></span>
</div>
<span class="label-right" *ngIf="labelRight">{{ labelRight }}</span>
